export const typography = {
    fonts: {
        'body.2xl': 'heading'
    },
    fontSizes: {
        'display.l': '60px',
        'display.m': '48px',
        'display.s': '32px',
        'heading.s': '16px'
    },
    lineHeights: {
        'display.l': '60px',
        'display.m': '48px',
        'display.s': '32px',
        'heading.s': '20px'
    },
    fontWeights: {
        'heading.m': 'medium',
        'body.2xl': 'bold',
        'body.m': 'bold',
        'body.xs': 'bold',
        'body.2xs': 'medium'
    }
};

//# sourceMappingURL=typography.js.map